import { FlatBorderCardStyled } from '@procurify/ui'
import styled, { css } from 'styled-components'

export const InteractiveCardStyled = styled.div<{ disabled?: boolean }>`
  ${FlatBorderCardStyled} {
    border-color: ${({ theme }) => theme.colors.form.field.border};
  }

  ${({ disabled }) =>
    !disabled &&
    css`
      cursor: pointer;
    `}
`
